var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', { staticClass: "g-tab-wrap" }, [_c('el-tabs', { attrs: { "type": "border-card" }, on: { "tab-click": _vm.handleClick }, model: { value: _vm.activeName, callback: function callback($$v) {
        _vm.activeName = $$v;
      }, expression: "activeName" } }, [_vm._l(_vm.tab, function (item) {
    return _c('el-tab-pane', { key: item.value, attrs: { "label": item.label, "name": item.value } });
  }), _vm._v(" "), _c('router-view')], 2)], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };